<span class="error-txt" [style.display]="isVisible || ! (reference && (reference.valid || reference.pristine))  ? 'block': ''">
  <ng-container *ngIf="customErrorText">
    <ng-content></ng-content>
  </ng-container>
  <ng-container *ngIf="!customErrorText">
    {{ 'Field is required' | translate }}
  </ng-container>
</span>